module.exports = __webpack_public_path__ + "static/assets/cb64c5d445f740053b5079d9331e2607.png";